'use client'

import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { createLumiApiClient } from "@/lib/lumi-api";

export const SignOutButton = () => {
  const router = useRouter();

  async function signOut() {
    await createLumiApiClient().logout();
    router.push("/");
    router.refresh();
  }

  return (
    <Button variant="destructive" onClick={signOut}>Log out</Button>
  )
}
